
<template>
    <div class="confirm-container">
        <helpInfo :helpData="helpData">
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpInfo>
        <div class="details"
             style="padding:15px 15px 0 15px">
            <!--注释说明-->
            <div class="top-productDesc">
                <div class="left">
                    <img src="@/assets/images/console/sfs.png" />
                </div>
                <div class="right">
                    <p>{{$t('1.如果降配则退还差价，只按照订单原始规格的价格进行计费，相关优惠券优惠部分不退还升配则需要补差价，相关优惠券需要补缴优惠部分金额。')}}</p>
                    <p>{{$t('2.补差价格 =（新规格周期价 / 本周期天数） x 本周期未使用剩余时长 - 原剩余时长价格  + 剩余周期差价。')}}</p>
                    <p>{{$t('3.原剩余时长价格 = （原规格周期价 / 本周期天数） x 本周期未使用剩余时长 ')}}</p>
                    <p>{{$t('4.若在变更配置前对资源进行了续订，续订周期变为本次变更配置的容量，需要对续订的周期进行资费的退还或补缴。')}}</p>
                    <p>{{$t('5.变更配置过程中，请勿对挂载的资源实例进行其他操作。')}}</p>
                    <p class="yellow">{{$t('注：本周期天数说明（示例：22年2月16日到22年3月16日为28天，22年3月16日到22年4月16日为31天）')}}</p>
                    <p class="yellow">{{$t('剩余周期差价说明：（示例：开通2月16日到5月16日50GB，250元/月，2月18日变配70GB，350元/月，剩余周期差价为3月16日到5月16日差价，(350-250)*2 = 200元）实际消费时长已使用部分精确到天，且变更配置当天按照新规格计费，不满一天按天计算。')}}</p>
                    <p class="yellow">{{$t('缩容当前资源有可能影响其他关联资源正常使用，例如会影响正在执行的训练作业，出现作业执行失败情况。请谨慎操作。')}}</p>
                </div>
            </div>
            <div v-show="!loading && currentStep==0"
                 class="instance-item">
                <div class="change-module">
                    <div class="left">
                        <h4>{{$t('当前配置')}}</h4>
                    </div>
                    <div class="right">
                        <Row v-if="details">
                            <Col span="8"
                                 v-for="(item,index) in details"
                                 :key="index"
                                 v-if="item.value!==null&&item.value!==''">
                            <div class="show-item"
                                 :title="$t(item.label)+'：'+item.value">
                                <span class="title">{{$t(item.label)}}：</span>
                                <span class="value">
                                    {{(item.value===null||item.value==='')?'--':item.value}}
                                </span>
                            </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="change-module">
                    <div class="left">
                        <h4>{{$t('变更配置')}}</h4>
                    </div>
                    <div class="right">
                        <!--弹性文件服务 -->
                        <sfsform ref="sfsform"
                                 v-if="type!=='SFS'&&data!==null"
                                 :data="data"
                                 :type="type"
                                 @sfsData="sfsData"></sfsform>
                    </div>
                </div>
            </div>
            <!--确认页面-->
            <div v-show="!loading&&currentStep===1">
                <confirmation ref="confirmation"
                              :configData="configData"></confirmation>
            </div>
            <div v-if="loading"
                 class="custom-loading"
                 style="height: 150px">
                <Spin fix>
                    <Icon type="ios-loading"
                          :size='24'
                          class="demo-spin-icon-load"></Icon>
                    <div>{{$t('加载中')}}</div>
                </Spin>
            </div>
        </div>
        <div class="apply-footer">
            <div class="footer-div">
                <div class="balance">
                    <span class="cost  rc-color-orange"
                          v-if="priceLoading ">
                        <Icon type="ios-loading"
                              size=16
                              class="demo-spin-icon-load"></Icon>
                        <span class="font-size14">
                            {{$t('计算中')}}...
                        </span>
                    </span>
                    <span class="cost rc-color-orange"
                          v-if="!priceLoading && priceData.price === null">
                        <span class="font-size14">{{$t('无法计算价格')}}</span>
                    </span>
                    <!-- 配置费用 -->
                    <p v-if="!priceLoading && priceData.price !== null">
                        <span class="config">
                            {{$t('新配置参考价')}}：<b>{{$money(priceData.price,5)}}{{isPrePaid?('/'+$t('月')):''}}</b>
                        </span>
                        <span class="config">
                            {{$t('补差金额')}}：<b>{{$money(priceData.amount,5)}}</b>
                        </span>
                    </p>
                </div>
                <div class="btn-div">
                    <Checkbox v-model="isCheck"
                              v-if="currentStep===1"> {{$t('我已确认本次变更规则和费用，实际扣减以最终订单金额为准')}}</Checkbox>
                    <Button @click="next()"
                            style="margin:0 0 0 10px;"
                            v-if="currentStep===1"
                            :loading="submitLoading">{{$t("上一步")}}</Button>
                    <Button @click="next()"
                            type="primary"
                            v-if="currentStep===0"
                            :disabled="isNext"
                            :loading="submitLoading">{{$t("下一步")}}</Button>
                    <Tooltip theme="light"
                             :disabled="noticeDrp.length==0"
                             placement="bottom-end"
                             :content="$t(noticeDrp)"
                             :transfer="true">
                        <Button @click="submit()"
                                type="primary"
                                style="margin:0 0 0 6px;"
                                v-if="currentStep===1"
                                :disabled="!isCheck||isAuthentStatus"
                                :loading="submitLoading">{{$t("完成")}}</Button>
                    </Tooltip>
                </div>
            </div>
        </div>
        <!--倒计时-->
        <countdown ref="countdown"
                   :txt="$t('变更操作成功，请稍后查看结果')"
                   :jumpTxt="$t('我的订单')"
                   jumpLink="/mgt/order">
        </countdown>
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import sfsform from './components/sfsform'
import confirmation from './components/confirmation'
import API from '@/service/api'
import countdown from '@c/basic/countdown'
export default {
    name: 'unsubscribe',
    components: {
        helpInfo,
        sfsform,
        confirmation,
        countdown
    },
    data () {
        return {
            priceLoading: false,
            currentStep: 0,
            loading: true,
            id: null,
            data: null,
            type: this.$route.query.type,
            envType: this.$route.query.envType,
            isCheck: false,
            isNext: true,
            submitLoading: false,
            helpData: {
                modelName: this.$t('变更配置')
            },
            configData: null,
            configAfter: null,
            details: [],
            isPrePaid: false,
            priceData: {
                price: 0,
                amount: 0
            }
        }
    },
    computed: {
        // 是否实名认证和企业认证
        isAuthentStatus () {
            const userAuth = this.$store.state.user.currentUser.info.authentStatus
            const comAuth = this.$store.state.user.currentOrg.certificationStatus
            // const flag = this.authType === 'company' ? comAuth !== 'authSucceed' : userAuth !== 'authSucceed'
            return !(comAuth === 'authSucceed' || userAuth === 'authSucceed')
        },
        noticeDrp () {
            if (this.isAuthentStatus) {
                return '账号未进行实名认证，无法执行该操作'
            } else {
                return ''
            }
        }
    },
    created () {
        this.loading = true
        this.getBilledStatus()
        this.init()
    },
    methods: {
        // 详情
        init () {
            this.isPrePaid = false
            this.loading = true
            const id = this.$route.query.id
            this.axios.get(this.urlFormat(API.RENEW_RESOURCR_DETAIL, false, [id])).then(res => {
                this.details = res.config
                this.data = res
                this.getBilledStatus()
                for (let i = 0; i < this.details.length; i++) {
                    if (this.details[i].label === 'ID') {
                        // 获取资源的ID
                        this.id = this.details[i].value
                    }
                    if (this.details[i].label === '计费类型' && this.details[i].value === '包年包月') {
                        // 判断是否包年包月
                        this.isPrePaid = true
                    }
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getBilledStatus () { // 用于判断是否不计费
            const { serviceId, chargeType, productCode } = this.data || {}
            if (!(serviceId && chargeType) || !['HPC-DRP', 'SFS2.0', 'DRP'].includes(productCode)) return // 判断是否计费， 一次就够了
            this.axios.get(this.urlFormat(API.BILLING_ISNONBILLPRODUCT), {
                params: { sfServiceId: serviceId, chargeType: chargeType }
            }).then(res => {
                this.notBilled = res
            })
        },
        next () {
            this.submitLoading = true
            switch (this.currentStep) {
                case 0:
                    // 下一步
                    if (this.type === 'SFS2.0') {
                        // 弹性文件服务
                        this.validateFun('sfsform')
                    }
                    break
                case 1:
                    // 上一步
                    this.submitLoading = false
                    this.currentStep -= 1
                    break
            }
        },
        validateFun (form) {
            this.submitLoading = false
            this.$refs[form].$refs.form.validate((valid) => {
                if (!valid) {
                    return false
                } else {
                    this.currentStep += 1
                    this.$refs.confirmation.open()
                }
            })
        },
        // 组装硬盘信息
        sfsData (data) {
            if (Number(data.changesize) > 0) {
                this.isNext = false
            } else {
                this.isNext = true
            }
            this.inquiry(data)
            this.configAfter = data
            this.configData = {
                name: this.$t('弹性文件服务'),
                config: this.details,
                before: [
                    { label: this.$t('容量'), value: this.data.size + 'GB' }
                ],
                after: [
                    { label: this.$t('容量'), value: Number(data.changesize) + 'GB' }
                ]
            }
        },
        // 询价
        inquiry (data) {
            this.priceLoading = true
            const params = {
                id: this.$route.query.id,
                targetType: 'SFS2.0',
                targetSize: data.changesize
            }
            this.priceData.price = null
            this.axios.get(this.urlFormat(API.GET_BILLING_MODIFY_INQUIRY_PRICE, false), {
                params: params
            }).then(res => {
                this.priceLoading = false
                this.priceData.amount = this.notBilled ? 0 : Number(res.amount)
                this.priceData.price = res.price
                this.loading = false
            }).catch(() => {
                this.priceLoading = false
                this.loading = false
            })
        },
        submit () {
            // 配置未改变不能提交数据
            const sfsStatus = (this.type === 'SFS2.0' && (Number(this.configAfter.changesize) === Number(this.data.size)))
            if (sfsStatus) {
                this.$Message.error(this.$t('配置未发生改变！'))
                return false
            }
            const params = {
                projectId: '',
                productInfo: {
                    id: String(this.$route.query.id),
                    size: this.configAfter.changesize,
                    resourceType: this.type
                }
            }
            this.submitLoading = true
            this.axios.post(this.urlFormat(API.POST_SERVICE_RESOIRCE, false), params).then(res => {
                // 变更成功进入倒计时
                if (res === 'SUCCESS' || res.status) {
                    this.submitLoading = false
                    this.isCheck = false
                    this.$refs.countdown.goChoicePeople()
                } else {
                    this.submitLoading = false
                }
            }).catch(() => {
                this.submitLoading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
.confirm-container {
    position: relative;
    background: #f5f6f7;
    height: 100%;
    .details {
        overflow-y: auto;
        height: calc(~'100% - 120px');
    }
    h4 {
        padding: 5px 0 20px 36px;
        font-size: 12px;
    }
    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .instance-item {
        .change-module {
            background: #fff;
            margin-bottom: 10px;
            padding: 15px 0 0px 0;
            min-height: 70px;
            .left {
                display: inline-block;
                width: 135px;
                float: left;
            }
            .right {
                display: inline-block;
                width: calc(~'100% - 135px');
            }
        }
        .show-item {
            margin-bottom: 15px;
            font-size: 12px;
            .title {
                display: inline-block;
                width: 120px;
                color: #999;
                text-align: right;
            }
            .value {
                display: inline-block;
                width: calc(~'100% - 120px');
                position: relative;
                top: 5px;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }
    .apply-footer {
        width: 100%;
        height: 60px;
        background: #fff;
        margin: 0 auto;
        border-top: 1px solid #e9e9e9;
        position: absolute;
        right: 0;
        bottom: 2px;
        .footer-div {
            width: 100%;
            height: 60px;
            padding: 0 15px;
            margin: 0;
            display: flex;
            .balance {
                width: 80%;
                height: 60px;
                line-height: 60px;
                padding-left: 10px;
                .config {
                    padding: 0 25px 0 0;
                    font-size: 12px;
                    width: 100%;
                    b {
                        font-weight: 500;
                        color: #f57d18;
                        font-size: 14px;
                    }
                }
            }
            .rc-color-orange {
                color: #f57d18;
            }
            .ivu-btn-text {
                border: 1px solid #ddd;
                margin: 0 6px 0 20px;
            }
            .btn-div {
                width: 90%;
                height: 60px;
                line-height: 60px;
                text-align: right;
                padding-right: 4px;
                float: right;
            }
        }
    }
    .top-productDesc {
        // width: 1200px;
        margin: 0 auto;
        background: #fff;
        margin-bottom: 10px;
        overflow: hidden;
        padding: 15px 0;
        display: flex;
        .left,
        .right {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .left {
            width: 200px;
            img {
                max-width: 100%;
            }
        }
        .right {
            width: calc(~'100% - 200px');
            line-height: 24px;
            p.yellow {
                color: #ff8400;
            }
            p {
                padding-left: 40px;
            }
        }
    }
}
</style>
